// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#reply-info{flex-grow:0}.reply-url{color:inherit;font-weight:700}", ""]);
// Exports
module.exports = exports;
